/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as JarfallaGuideRouteImport } from './routes/jarfalla.guide'
import { Route as LoginIndexRouteImport } from './routes/login.index'
import { Route as OmBarnUtbildningRouteImport } from './routes/om.barn-utbildning'
import { Route as OmBostaderRouteImport } from './routes/om.bostader'
import { Route as OmDataRouteImport } from './routes/om.data'
import { Route as OmGuideRouteImport } from './routes/om.guide'
import { Route as OmKonInkomstRouteImport } from './routes/om.kon-inkomst'
import { Route as OmLyckoparadoxenRouteImport } from './routes/om.lyckoparadoxen'
import { Route as OmOmRouteImport } from './routes/om.om'
import { Route as OmSocioekonomiRouteImport } from './routes/om.socioekonomi'
import { Route as TableIndexRouteImport } from './routes/table.index'
import { Route as ToolIndexRouteImport } from './routes/tool.index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const JarfallaGuideRoute = JarfallaGuideRouteImport.update({
  id: '/jarfalla/guide',
  path: '/jarfalla/guide',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const OmBarnUtbildningRoute = OmBarnUtbildningRouteImport.update({
  id: '/om/barn-utbildning',
  path: '/om/barn-utbildning',
  getParentRoute: () => rootRouteImport,
} as any)
const OmBostaderRoute = OmBostaderRouteImport.update({
  id: '/om/bostader',
  path: '/om/bostader',
  getParentRoute: () => rootRouteImport,
} as any)
const OmDataRoute = OmDataRouteImport.update({
  id: '/om/data',
  path: '/om/data',
  getParentRoute: () => rootRouteImport,
} as any)
const OmGuideRoute = OmGuideRouteImport.update({
  id: '/om/guide',
  path: '/om/guide',
  getParentRoute: () => rootRouteImport,
} as any)
const OmKonInkomstRoute = OmKonInkomstRouteImport.update({
  id: '/om/kon-inkomst',
  path: '/om/kon-inkomst',
  getParentRoute: () => rootRouteImport,
} as any)
const OmLyckoparadoxenRoute = OmLyckoparadoxenRouteImport.update({
  id: '/om/lyckoparadoxen',
  path: '/om/lyckoparadoxen',
  getParentRoute: () => rootRouteImport,
} as any)
const OmOmRoute = OmOmRouteImport.update({
  id: '/om/om',
  path: '/om/om',
  getParentRoute: () => rootRouteImport,
} as any)
const OmSocioekonomiRoute = OmSocioekonomiRouteImport.update({
  id: '/om/socioekonomi',
  path: '/om/socioekonomi',
  getParentRoute: () => rootRouteImport,
} as any)
const TableIndexRoute = TableIndexRouteImport.update({
  id: '/table/',
  path: '/table/',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolIndexRoute = ToolIndexRouteImport.update({
  id: '/tool/',
  path: '/tool/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/jarfalla/guide': typeof JarfallaGuideRoute
  '/om/barn-utbildning': typeof OmBarnUtbildningRoute
  '/om/bostader': typeof OmBostaderRoute
  '/om/data': typeof OmDataRoute
  '/om/guide': typeof OmGuideRoute
  '/om/kon-inkomst': typeof OmKonInkomstRoute
  '/om/lyckoparadoxen': typeof OmLyckoparadoxenRoute
  '/om/om': typeof OmOmRoute
  '/om/socioekonomi': typeof OmSocioekonomiRoute
  '/login/': typeof LoginIndexRoute
  '/table/': typeof TableIndexRoute
  '/tool/': typeof ToolIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/jarfalla/guide': typeof JarfallaGuideRoute
  '/om/barn-utbildning': typeof OmBarnUtbildningRoute
  '/om/bostader': typeof OmBostaderRoute
  '/om/data': typeof OmDataRoute
  '/om/guide': typeof OmGuideRoute
  '/om/kon-inkomst': typeof OmKonInkomstRoute
  '/om/lyckoparadoxen': typeof OmLyckoparadoxenRoute
  '/om/om': typeof OmOmRoute
  '/om/socioekonomi': typeof OmSocioekonomiRoute
  '/login': typeof LoginIndexRoute
  '/table': typeof TableIndexRoute
  '/tool': typeof ToolIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/jarfalla/guide': typeof JarfallaGuideRoute
  '/om/barn-utbildning': typeof OmBarnUtbildningRoute
  '/om/bostader': typeof OmBostaderRoute
  '/om/data': typeof OmDataRoute
  '/om/guide': typeof OmGuideRoute
  '/om/kon-inkomst': typeof OmKonInkomstRoute
  '/om/lyckoparadoxen': typeof OmLyckoparadoxenRoute
  '/om/om': typeof OmOmRoute
  '/om/socioekonomi': typeof OmSocioekonomiRoute
  '/login/': typeof LoginIndexRoute
  '/table/': typeof TableIndexRoute
  '/tool/': typeof ToolIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/jarfalla/guide'
    | '/om/barn-utbildning'
    | '/om/bostader'
    | '/om/data'
    | '/om/guide'
    | '/om/kon-inkomst'
    | '/om/lyckoparadoxen'
    | '/om/om'
    | '/om/socioekonomi'
    | '/login/'
    | '/table/'
    | '/tool/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/jarfalla/guide'
    | '/om/barn-utbildning'
    | '/om/bostader'
    | '/om/data'
    | '/om/guide'
    | '/om/kon-inkomst'
    | '/om/lyckoparadoxen'
    | '/om/om'
    | '/om/socioekonomi'
    | '/login'
    | '/table'
    | '/tool'
  id:
    | '__root__'
    | '/'
    | '/jarfalla/guide'
    | '/om/barn-utbildning'
    | '/om/bostader'
    | '/om/data'
    | '/om/guide'
    | '/om/kon-inkomst'
    | '/om/lyckoparadoxen'
    | '/om/om'
    | '/om/socioekonomi'
    | '/login/'
    | '/table/'
    | '/tool/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  JarfallaGuideRoute: typeof JarfallaGuideRoute
  OmBarnUtbildningRoute: typeof OmBarnUtbildningRoute
  OmBostaderRoute: typeof OmBostaderRoute
  OmDataRoute: typeof OmDataRoute
  OmGuideRoute: typeof OmGuideRoute
  OmKonInkomstRoute: typeof OmKonInkomstRoute
  OmLyckoparadoxenRoute: typeof OmLyckoparadoxenRoute
  OmOmRoute: typeof OmOmRoute
  OmSocioekonomiRoute: typeof OmSocioekonomiRoute
  LoginIndexRoute: typeof LoginIndexRoute
  TableIndexRoute: typeof TableIndexRoute
  ToolIndexRoute: typeof ToolIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/jarfalla/guide': {
      id: '/jarfalla/guide'
      path: '/jarfalla/guide'
      fullPath: '/jarfalla/guide'
      preLoaderRoute: typeof JarfallaGuideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/om/barn-utbildning': {
      id: '/om/barn-utbildning'
      path: '/om/barn-utbildning'
      fullPath: '/om/barn-utbildning'
      preLoaderRoute: typeof OmBarnUtbildningRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/om/bostader': {
      id: '/om/bostader'
      path: '/om/bostader'
      fullPath: '/om/bostader'
      preLoaderRoute: typeof OmBostaderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/om/data': {
      id: '/om/data'
      path: '/om/data'
      fullPath: '/om/data'
      preLoaderRoute: typeof OmDataRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/om/guide': {
      id: '/om/guide'
      path: '/om/guide'
      fullPath: '/om/guide'
      preLoaderRoute: typeof OmGuideRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/om/kon-inkomst': {
      id: '/om/kon-inkomst'
      path: '/om/kon-inkomst'
      fullPath: '/om/kon-inkomst'
      preLoaderRoute: typeof OmKonInkomstRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/om/lyckoparadoxen': {
      id: '/om/lyckoparadoxen'
      path: '/om/lyckoparadoxen'
      fullPath: '/om/lyckoparadoxen'
      preLoaderRoute: typeof OmLyckoparadoxenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/om/om': {
      id: '/om/om'
      path: '/om/om'
      fullPath: '/om/om'
      preLoaderRoute: typeof OmOmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/om/socioekonomi': {
      id: '/om/socioekonomi'
      path: '/om/socioekonomi'
      fullPath: '/om/socioekonomi'
      preLoaderRoute: typeof OmSocioekonomiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/table/': {
      id: '/table/'
      path: '/table'
      fullPath: '/table/'
      preLoaderRoute: typeof TableIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tool/': {
      id: '/tool/'
      path: '/tool'
      fullPath: '/tool/'
      preLoaderRoute: typeof ToolIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  JarfallaGuideRoute: JarfallaGuideRoute,
  OmBarnUtbildningRoute: OmBarnUtbildningRoute,
  OmBostaderRoute: OmBostaderRoute,
  OmDataRoute: OmDataRoute,
  OmGuideRoute: OmGuideRoute,
  OmKonInkomstRoute: OmKonInkomstRoute,
  OmLyckoparadoxenRoute: OmLyckoparadoxenRoute,
  OmOmRoute: OmOmRoute,
  OmSocioekonomiRoute: OmSocioekonomiRoute,
  LoginIndexRoute: LoginIndexRoute,
  TableIndexRoute: TableIndexRoute,
  ToolIndexRoute: ToolIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
